// features/videos/real/chips.ts — the concept's chip row and the Featured 'why' lines.
import type { FilterChipDef } from '@/components/FilterChips/FilterChips';
import type { FeaturedReason } from '@/core/services/videoFeedService';

export type RealChipId =
  | 'all'
  | 'following'
  | 'trending'
  | 'live'
  | 'flash'
  | 'gaming'
  | 'news'
  | 'education'
  | 'music'
  | 'tech'
  | 'sports';

export const REAL_CHIPS: FilterChipDef<RealChipId>[] = [
  { id: 'all', label: 'All' },
  { id: 'following', label: 'Following' },
  { id: 'trending', label: 'Trending' },
  { id: 'live', label: 'Live', dot: true },
  { id: 'flash', label: 'Flash', icon: 'flash' },
  { id: 'gaming', label: 'Gaming', icon: 'gamepad' },
  { id: 'news', label: 'News', icon: 'newspaper' },
  { id: 'education', label: 'Education', icon: 'graduation-cap' },
  { id: 'music', label: 'Music', icon: 'music' },
  { id: 'tech', label: 'Tech', icon: 'cpu' },
  { id: 'sports', label: 'Sports', icon: 'trophy' },
];

export const CHIP_IDS = new Set<string>(REAL_CHIPS.map((c) => c.id));

// Shown under the hero's title, next to its "Most Featured" pill — so no "Featured:" prefix.
export const FEATURED_REASON: Record<FeaturedReason, string> = {
  rising: 'The fastest-rising video in the last 48 hours',
  trending: 'The most-watched video this week',
  newest: 'The newest video',
};
